import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header cursor-pointer bg-success" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0 text-light" }, " Training Partner Contract Details ")
  ])
], -1)
const _hoisted_3 = { class: "card-body pt-9 pb-0" }
const _hoisted_4 = { class: "row mb-7" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Tranche", -1)
const _hoisted_6 = { class: "col-lg-8" }
const _hoisted_7 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_8 = { class: "row mb-7" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Training Partner", -1)
const _hoisted_10 = { class: "col-lg-8 fv-row" }
const _hoisted_11 = { class: "fw-bold fs-6" }
const _hoisted_12 = { class: "row mb-7" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Contract Number", -1)
const _hoisted_14 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_15 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_16 = { class: "row mb-7" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Contract Name", -1)
const _hoisted_18 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_19 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_20 = { class: "row mb-7" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Sign Date", -1)
const _hoisted_22 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_23 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_24 = { class: "row mb-7" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Start Date", -1)
const _hoisted_26 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_27 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_28 = { class: "row mb-7" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "End Date", -1)
const _hoisted_30 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_31 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_32 = { class: "row mb-7" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Target", -1)
const _hoisted_34 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_35 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_36 = { class: "row mb-7" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Amount", -1)
const _hoisted_38 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_39 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_40 = { class: "row mb-7" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Contribution Percentage %", -1)
const _hoisted_42 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_43 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_44 = { class: "row mb-7" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Adjustable Advance Amount ", -1)
const _hoisted_46 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_47 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_48 = { class: "row mb-7" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Min Age", -1)
const _hoisted_50 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_51 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_52 = { class: "row mb-7" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Max Age", -1)
const _hoisted_54 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_55 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_56 = { class: "row mb-7" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Grace(M)", -1)
const _hoisted_58 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_59 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_60 = { class: "row mb-7" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Attachment", -1)
const _hoisted_62 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_63 = { class: "list-group list-group-numbered p-0" }
const _hoisted_64 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(this.contractInfo?.tranche?.label), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, "[" + _toDisplayString(this.contractInfo?.entity?.entity_short_name) + "]-" + _toDisplayString(this.contractInfo?.entity?.entity_name), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, _toDisplayString(this.contractInfo?.contract_number), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("span", _hoisted_19, _toDisplayString(this.contractInfo?.contract_name), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", _hoisted_23, _toDisplayString(this.contractInfo.sign_date
                    ? _ctx.moment(this.contractInfo.sign_date).format("DD-MM-YYYY")
                    : ""), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("span", _hoisted_27, _toDisplayString(this.contractInfo.start
                    ? _ctx.moment(this.contractInfo.start).format("DD-MM-YYYY")
                    : ""), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("span", _hoisted_31, _toDisplayString(this.contractInfo.end
                    ? _ctx.moment(this.contractInfo.end).format("DD-MM-YYYY")
                    : ""), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("span", _hoisted_35, _toDisplayString(this.contractInfo?.target), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _hoisted_37,
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("span", _hoisted_39, _toDisplayString(this.contractInfo?.amount), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _hoisted_41,
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("span", _hoisted_43, _toDisplayString(this.contractInfo?.contribution_percentage), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_44, [
        _hoisted_45,
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("span", _hoisted_47, _toDisplayString(this.contractInfo?.adjustable_advance_amount), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_48, [
        _hoisted_49,
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("span", _hoisted_51, _toDisplayString(this.contractInfo?.min_age), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_52, [
        _hoisted_53,
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("span", _hoisted_55, _toDisplayString(this.contractInfo?.max_age), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_56, [
        _hoisted_57,
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("span", _hoisted_59, _toDisplayString(this.contractInfo?.age_grace_in_month), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_60, [
        _hoisted_61,
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("ol", _hoisted_63, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.contractInfo?.attach_file_info, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "list-group-item border-0 px-0",
                key: index
              }, [
                _createElementVNode("a", {
                  href: this.api_url + item?.file_path,
                  target: "_blank"
                }, _toDisplayString(item?.file_name_original), 9, _hoisted_64)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ])), [
    [_directive_loading, _ctx.load]
  ])
}